<ng-container *ngIf="isLoadingProductListPage; else showProductListPage">
  <div class="loading-container">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
</ng-container>
<ng-template #showProductListPage>
  <mat-sidenav-container class="product-list-wrapper">
    <mat-sidenav #sidenav (closed)="onClose()" [mode]="mode.value" [(opened)]="sideNavOpened">
      <div class="close-icon">
        <mat-icon (click)="sidenav.close()" class="material-icons-sharp md-12">clear</mat-icon>
      </div>
      <div class="side-nav-sorting" *ngIf="model$ | async as model">
        <div *ngIf="model.products.length > 0" class="container">
          <div class="row">
            <div class="col-12 sort-label">
              {{ 'product.productSorting.title' | cxTranslate }}
            </div>
            <div class="col-12 form-wrapper">
              <div class="form-group cx-sort-dropdown">
                <app-product-sorting
                  [sortOptions]="model.sorts"
                  (sortListEvent)="sortList($event)"
                  [selectedOption]="model.pagination.sort"
                  [sidenav]="'true'"
                  placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
                ></app-product-sorting>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-product-refinement [sidenavopen]="isSideNaveOpen" [sidenav]="'true'"></app-product-refinement>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="cx-page" *ngIf="model$ | async as model">
        <section class="search-results-section" *ngIf="isSearchPage">
          <app-search-results-info [count]="model.pagination.totalResults"></app-search-results-info>
          <app-spelling-suggestion [didYouMean]="model.spellingSuggestion"></app-spelling-suggestion>
        </section>
        <section class="cx-page-section">
          <div class="container-fluid">
            <div class="row no-gutters">
              <div class="col-12 col-lg-12" *ngIf="viewMode$ | async as viewMode">
                <button class="btn-sort-filter" (click)="toggleSidenav()">
                  <mat-icon class="light" svgIcon="filter"></mat-icon>
                  {{ 'product.productSorting.sortFilter' | cxTranslate }}
                </button>
                <div *ngIf="model.products.length > 0" class="cx-sorting top">
                  <div class="row">
                    <div class="col-12 col-lg-4 mr-auto">
                      <div class="form-group cx-sort-dropdown">
                        <app-product-sorting
                          [sortOptions]="model.sorts"
                          (sortListEvent)="sortList($event)"
                          [selectedOption]="model.pagination.sort"
                          placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
                        ></app-product-sorting>
                      </div>
                    </div>
                    <div *ngIf="!isInfiniteScroll" class="col-auto">
                      <div
                        class="cx-pagination"
                        [attr.aria-label]="'productList.productSearchPagination' | cxTranslate"
                      >
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                        ></cx-pagination>
                      </div>
                    </div>
                    <div class="col-auto ml-auto ml-lg-0 product-view-wrapper">
                      <app-product-view
                        class="product-view"
                        (modeChange)="setViewMode($event)"
                        [mode]="ViewModes.Grid"
                      ></app-product-view>
                      <app-product-view
                        class="product-view"
                        (modeChange)="setViewMode($event)"
                        [mode]="ViewModes.List"
                      ></app-product-view>
                    </div>
                  </div>
                </div>
                <div
                  class="cx-product-container"
                  [ngClass]="{
                    'popup-enabled': isPlpPopupEnabled
                  }"
                >
                  <!-- IF EMPTY PRODUCTS -->
                  <ng-container *ngIf="model.products.length < 1">
                    <label>{{ 'product.productList.noProducts' | cxTranslate }}</label>
                  </ng-container>
                  <!-- Product list when using pagination -->
                  <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">
                    <ng-container *ngIf="viewMode === ViewModes.Grid">
                      <div id="app-product-grid-item-main-wrapper">
                        <app-product-grid-item
                          *ngFor="let product of productListResults; let i = index"
                          [product]="product"
                          [dealerPrices]="dealerPrices"
                          [isSearchPage]="isSearchPage"
                          [position]="i + 1"
                          [hasDealerPrice]="hasDealerPrice"
                          class="col-12 col-sm-6 col-md-4"
                        ></app-product-grid-item>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewModes.List && model.products.length > 0">
                      <app-product-list-item
                        *ngFor="let product of productListResults; let i = index"
                        [product]="product"
                        [dealerPrices]="dealerPrices"
                        [isSearchPage]="isSearchPage"
                        [position]="i + 1"
                        [hasDealerPrice]="hasDealerPrice"
                        [basepriceHidden]="basepriceHidden"
                        class="app-product-search-list"
                      ></app-product-list-item>
                    </ng-container>
                  </ng-container>

                  <!-- Product list when using infinite scroll -->
                  <ng-template #infiniteScroll>
                    <app-shimano-product-scroll
                      [scrollConfig]="scrollConfig"
                      [model]="model"
                      [inputViewMode]="viewMode"
                      [productListResults]="productListResults"
                      [cachedlastPage]="cachedLastPage"
                      [isCachedLastPage]="cachedLastPage === model.pagination.totalPages - 1"
                    ></app-shimano-product-scroll>
                  </ng-template>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row">
                    <label class="form-group cx-sort-dropdown col-12 col-lg-4 mr-auto"> </label>
                    <div
                      *ngIf="!isInfiniteScroll"
                      class="col-auto"
                      [attr.aria-label]="'productList.productSearchPagination' | cxTranslate"
                    >
                      <div class="cx-pagination">
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                        ></cx-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-template>
